import React, { useState, useEffect } from 'react';
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  Switch,
  Space,
  Typography,
  message,
  Tabs,
  Descriptions,
  Select,
  Spin
} from 'antd';
import {
  MessageOutlined,
  FileTextOutlined,
  CheckOutlined,
  CloseOutlined,
  EditOutlined,
  LoadingOutlined
} from '@ant-design/icons';
import { useAuth } from '../../context/DBContext'; // Adjust the import path
import { functions } from '../../firebase_setup';
const { Title, Text, Link } = Typography;
const { Search } = Input;
const { TabPane } = Tabs;
const { Option } = Select;

const AdminBusinessManagement = () => {

  const { 
    fetchBusinessUsers, 
    updateBusiness, 
    sendMessage, 
    fetchUserStatus, 
    currentUser, 
    fetchPendingBusinessUsers, 
    approveBusinessUser, 
    denyBusinessUser,
    fetchPendingServiceClaims, 
    approveServiceClaim,      
    denyServiceClaim,     
    fetchServiceById,
    getUserInfo
  } = useAuth();
// States for businesses
const [businesses, setBusinesses] = useState([]);
const [filteredBusinesses, setFilteredBusinesses] = useState([]);
const [loadingBusinesses, setLoadingBusinesses] = useState(true);
const [searchValue, setSearchValue] = useState('');
const [currentPage, setCurrentPage] = useState(1); // For pagination
const [pageSize, setPageSize] = useState(10);
const [loadingStates, setLoadingStates] = useState({});
const [loadingAction, setLoadingAction] = useState(false);
const [form] = Form.useForm();

// States for modals
const [selectedBusiness, setSelectedBusiness] = useState(null);
const [isViewModalVisible, setIsViewModalVisible] = useState(false);
const [editingBusiness, setEditingBusiness] = useState(null);
const [isEditModalVisible, setIsEditModalVisible] = useState(false);
const [isMessageModalVisible, setIsMessageModalVisible] = useState(false);
const [messageContent, setMessageContent] = useState('');
const [recipient, setRecipient] = useState(null);


  // States for handling modals and editing

  const [isServiceModalVisible, setIsServiceModalVisible] = useState(false);
  const [selectedServiceClaim, setSelectedServiceClaim] = useState(null);

  // States for search queries
  const [pendingSearch, setPendingSearch] = useState('');
  const [approvedSearch, setApprovedSearch] = useState('');
  const [serviceSearch, setServiceSearch] = useState('');

  // Filtered lists based on approval status and search
  const [filteredApproved, setFilteredApproved] = useState([]);
  const [filteredServiceClaims, setFilteredServiceClaims] = useState([]);

  const [pendingBusinesses, setPendingBusinesses] = useState([]); // All pending businesses
  const [filteredPending, setFilteredPending] = useState([]); // Filtered pending businesses
  
  // State for pagination of pending businesses
const [currentPendingPage, setCurrentPendingPage] = useState(1);
const [pageSizePending, setPageSizePending] = useState(10);

// States for Pending Service Approvals**
const [currentServicePage, setCurrentServicePage] = useState(1);
const [pageSizeService, setPageSizeService] = useState(10);
const [loadingServiceClaims, setLoadingServiceClaims] = useState(false);
useEffect(() => {
  async function loadBusinesses() {
      try {
          const fetchedBusinesses = await fetchBusinessUsers();

          // Filter businesses by `selectedAuthorityId` equal to `currentUser.uid`
          const filteredBusinessesByAuthority = fetchedBusinesses
              .filter(business => business.localAuthorityId === currentUser.uid)
              .map(business => ({
                  ...business,
                  createdAt: business.createdAt?.toDate().toString() // Convert Timestamp to string
              }));

          setBusinesses(filteredBusinessesByAuthority);
          setFilteredBusinesses(filteredBusinessesByAuthority);

          // Initialize loading states
          const initialLoadingStates = {};
          filteredBusinessesByAuthority.forEach(business => {
              initialLoadingStates[business.id] = false;
          });
          setLoadingStates(initialLoadingStates);
      } catch (error) {
          message.error("Failed to load businesses.");
      } finally {
          setLoadingBusinesses(false);
      }
  }
  loadBusinesses();
}, [currentUser.uid]);



// Filter businesses based on searchValue
useEffect(() => {
  const filtered = businesses.filter(business =>
    Object.keys(business).some(key =>
      String(business[key]).toLowerCase().includes(searchValue.toLowerCase())
    )
  );
  setFilteredBusinesses(filtered);
}, [businesses, searchValue]);

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    sorter: (a, b) => a.name.localeCompare(b.name),
    // render: (text, record) => (
    //   <a onClick={() => viewBusiness(record)}>{text}</a>
    // ),
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
  },
  {
    title: 'Role',
    dataIndex: 'businessRole',
    key: 'businessRole',
    sorter: (a, b) => a.businessRole.localeCompare(b.businessRole),
  },
  // {
  //   title: 'Status',
  //   dataIndex: 'active',
  //   key: 'active',
  //   render: (active, record) => (
  //     <Switch
  //       checked={active}
  //       onChange={() => toggleBusinessStatus(record)}
  //       checkedChildren="Active"
  //       unCheckedChildren="Inactive"
  //       loading={loadingStates[record.id]}  // Use specific loading state
  //       />
  //   ),
  //   sorter: (a, b) => a.active - b.active,
  // },
  {
    title: 'Actions',
    key: 'actions',
    render: (_, record) => (
      <Space size="middle">
        <Button icon={<MessageOutlined />} onClick={() => messageBusiness(record)}>
          Message
        </Button>
     
      </Space>
    ),
  },
];


// useEffect for loading pending businesses initially// useEffect to load pending businesses
useEffect(() => {
  async function loadPendingBusinesses() {
    setLoadingBusinesses(true); // Optionally manage a separate loading state for pending businesses
    try {
      const pendingBusinesses = await fetchPendingBusinessUsers();
      const convertedBusinesses = pendingBusinesses.map(business => ({
        ...business,
        createdAt: business.createdAt?.toDate().toString() // Convert Timestamp to string
      }));
      setPendingBusinesses(convertedBusinesses);
      setFilteredPending(convertedBusinesses);
    } catch (error) {
      message.error("Failed to load pending businesses: " + error.message);
    } finally {
      setLoadingBusinesses(false);
    }
  }

  loadPendingBusinesses();
}, []);
useEffect(() => {
  const filtered = businesses.filter(business =>
    Object.keys(business).some(key =>
      String(business[key]).toLowerCase().includes(searchValue.toLowerCase())
    )
  );
  setFilteredBusinesses(filtered);
}, [businesses, searchValue]);

useEffect(() => {
  const filtered = pendingBusinesses.filter(business => 
    business.name.toLowerCase().includes(pendingSearch.toLowerCase()) ||
    business.email.toLowerCase().includes(pendingSearch.toLowerCase())
  );
  setFilteredPending(filtered);
}, [pendingSearch, pendingBusinesses]);

  // Approve a business with immediate reflection in Business tab
  const approveBusiness = async (businessId) => {
    Modal.confirm({
      title: 'Are you sure?',
      content: 'Do you want to approve this business?',
      okText: 'Yes',
      okType: 'primary',
      cancelText: 'No',
      onOk: async () => {
        setLoadingAction(true);
        try {
          await approveBusinessUser(businessId);
          message.success("Business approved successfully");
          
          // Remove from pending
          setFilteredPending(prev => prev.filter(b => b.id !== businessId));
          
          // Fetch disabled status
          const disabledStatus = await fetchUserStatus(businessId);
          const active = !disabledStatus;
          
          // Find the approved business data
          const approvedBusiness = pendingBusinesses.find(b => b.id === businessId);
          if (approvedBusiness) {
            setBusinesses(prev => [...prev, { ...approvedBusiness, active }]);
            setFilteredBusinesses(prev => [...prev, { ...approvedBusiness, active }]);
          }
        } catch (error) {
          message.error("Failed to approve business: " + error.message);
        } finally {
          setLoadingAction(false);
        }
      }
    });
  };

  // Deny a business
  const denyBusiness = async (businessId) => {
    Modal.confirm({
      title: 'Are you sure?',
      content: 'Do you want to deny this business?',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk: async () => {
        setLoadingAction(true);
        try {
          await denyBusinessUser(businessId);
          message.success("Business denied");
          
          // Remove from pending
          setFilteredPending(prev => prev.filter(b => b.id !== businessId));
          
          // Optionally, remove from businesses if needed
          // setBusinesses(prev => prev.filter(b => b.id !== businessId));
        } catch (error) {
          message.error("Failed to deny business: " + error.message);
        } finally {
          setLoadingAction(false);
        }
      }
    });
  };



const viewBusiness = (business) => {
  setSelectedBusiness(business);
  setIsViewModalVisible(true);
};

const handleViewCancel = () => {
  setIsViewModalVisible(false);
};

const toggleBusinessStatus = async (business) => {
  setLoadingStates(prev => ({ ...prev, [business.id]: true }));  // Set loading true for specific business
  try {
    const newStatus = !business.active;
    const result = await functions.httpsCallable('toggleUserStatus')({
      userId: business.id,
      disable: business.active,
    });
    if (result.data.success) {
      setBusinesses(prevBusinesses =>
        prevBusinesses.map(b =>
          b.id === business.id ? { ...b, active: newStatus } : b
        )
      );
      message.success(`Business ${newStatus ? 'activated' : 'deactivated'} successfully.`);
    } else {
      message.error(result.data.message);
    }
  } catch (error) {
    message.error('Failed to update business status.');
    // console.error('Error toggling business status:', error);
  } finally {
    setLoadingStates(prev => ({ ...prev, [business.id]: false }));  // Set loading false for specific business
  }
};

const editBusiness = (business) => {
  setEditingBusiness(business);
  form.setFieldsValue(business);
  setIsEditModalVisible(true);
};

const handleEditOk = async () => {
  setLoadingAction(true);
  if (editingBusiness) {
    const updatedData = form.getFieldsValue();
    await updateBusiness(editingBusiness.id, updatedData);

    setBusinesses(prevBusinesses =>
      prevBusinesses.map(b =>
        b.id === editingBusiness.id ? { ...b, ...updatedData } : b
      )
    );

    message.success('Business details updated successfully.');
    setIsEditModalVisible(false);
    setEditingBusiness(null);
    setLoadingAction(false);
  }
};

const handleEditCancel = () => {
  setIsEditModalVisible(false);
};

const messageBusiness = (business) => {
  setRecipient(business);
  setIsMessageModalVisible(true);
};

const messageAllBusinesses = () => {
  setRecipient(null);
  setIsMessageModalVisible(true);
};

const handleSendMessage = async () => {
  setLoadingAction(true);
  if (recipient) {
    try {
      await sendMessage(currentUser.uid, recipient.name, recipient.id, messageContent);
      message.success(`Message sent to ${recipient.name}`);
    } catch (error) {
      message.error('Failed to send message to the business.');
      // console.error('Error sending message:', error);
    }
  } else {
    try {
      await Promise.all(
        businesses.map(business =>
          sendMessage(currentUser.uid, business.name, business.id, messageContent)
        )
      );
      message.success('Message sent to all businesses.');
    } catch (error) {
      message.error('Failed to send message to all businesses.');
      // console.error('Error sending message:', error);
    }
  }
  setIsMessageModalVisible(false);
  setLoadingAction(false);
};

const generateBusinessReport = (business) => {
  message.info(`Generating report for ${business.name}.`);
};

const generateAllBusinessesReport = () => {
  message.info('Generating report for all businesses.');
};

const handlePageChange = (page, newPageSize) => {
  setCurrentPage(page);
  setPageSize(newPageSize);
};


useEffect(() => {
  const startIndex = (currentPendingPage - 1) * pageSizePending;
  const endIndex = startIndex + pageSizePending;
  setFilteredPending(pendingBusinesses.slice(startIndex, endIndex));
}, [pendingBusinesses, currentPendingPage, pageSizePending]);

const [serviceClaims, setServiceClaims] = useState([]);




  // Effect to filter service claims based on status and search
  useEffect(() => {
    const pendingServices = serviceClaims.filter(
      (sc) =>
        sc.status === 'Pending' && matchesServiceSearch(sc, serviceSearch)
    );
    setFilteredServiceClaims(pendingServices);
  }, [serviceClaims, serviceSearch]);

  // Helper function to check if a business matches the search query
  const matchesSearch = (business, query) => {
    if (!query) return true;
    const lowerQuery = query.toLowerCase();
    return Object.keys(business).some(
      (key) =>
        key !== 'documents' && // Exclude 'documents' from search to prevent long URLs
        String(business[key]).toLowerCase().includes(lowerQuery)
    );
  };

  // Helper function to check if a service claim matches the search query
  const matchesServiceSearch = (serviceClaim, query) => {
    if (!query) return true;
    const lowerQuery = query.toLowerCase();
    return (
      serviceClaim.businessName.toLowerCase().includes(lowerQuery) ||
      serviceClaim.serviceName.toLowerCase().includes(lowerQuery) ||
      serviceClaim.serviceDetails.toLowerCase().includes(lowerQuery)
    );
  };
  

  
  const pendingColumns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      // render: (text, record) => (
      //   <a onClick={() => viewBusiness(record)}>{text}</a>
      // ),      
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      sorter: (a, b) => a.businessRole.localeCompare(b.businessRole),

    },
    {
      title: 'Location',
      dataIndex: 'location',
      key: 'location',

    },
    {
      title: 'Role',
      dataIndex: 'businessRole', // Changed from 'role' to 'businessRole'
      key: 'businessRole',
  
    },
   
    // {
    //   title: 'Actions',
    //   key: 'actions',
    //   width: 200,

    //   render: (_, record) => (
    //     <Space size="middle">
    //       <Button 
    //         onClick={() => approveBusiness(record.id)} 
    //         type="primary" 
    //         icon={<CheckOutlined />}
    //         size="small"

    //       >
    //         Approve
    //       </Button>
    //       <Button 
    //         onClick={() => denyBusiness(record.id)} 
    //         type="danger" 
    //         icon={<CloseOutlined />}
    //         size="small"

    //       >
    //         Deny
    //       </Button>
    //     </Space>
    //   ),
    // },
  ];
  

  // **Fetch Pending Service Claims**
 // **Fetch Pending Service Claims**
useEffect(() => {
  async function loadPendingServiceClaims() {
    setLoadingServiceClaims(true);
    // console.log('Attempting to load pending service claims...'); // Debug
    try {
      const claims = await fetchPendingServiceClaims();
      // console.log('Fetched pending service claims:', claims); // Debug
      setServiceClaims(claims);
      setFilteredServiceClaims(claims);
    } catch (error) {
      // console.error("Failed to load pending service claims:", error);
      message.error("Failed to load pending service claims.");
    } finally {
      setLoadingServiceClaims(false);
    }
  }

  loadPendingServiceClaims();
}, [fetchPendingServiceClaims]);


 // **Filter Service Claims based on `serviceSearch`**
useEffect(() => {
  const filtered = serviceClaims.filter(sc =>
    sc.businessName.toLowerCase().includes(serviceSearch.toLowerCase()) ||
    sc.serviceName.toLowerCase().includes(serviceSearch.toLowerCase()) ||
    sc.serviceDetails.toLowerCase().includes(serviceSearch.toLowerCase())
  );
  // console.log('Filtered service claims:', filtered); // Debug
  setFilteredServiceClaims(filtered);
}, [serviceSearch, serviceClaims]);
const fetchAndShowBusiness = async (businessId) => {
  try {
    const business = await getUserInfo(businessId);  // getUserInfo should fetch complete business data
    if (business) {
      // Convert createdAt to a string if it exists and is a Timestamp
      if (business.createdAt?.toDate) {
        business.createdAt = business.createdAt.toDate().toString();
      }
      setSelectedBusiness(business);
      setIsViewModalVisible(true);
    } else {
      message.error('Business details not found.');
    }
  } catch (error) {
    // console.error('Failed to fetch business details:', error);
    message.error('Failed to load business details.');
  }
};




// **Define Columns for Pending Service Approvals Tab**// Define Columns for Pending Service Approvals Tab
const serviceClaimsColumns = [
  {
    title: 'Business Name',
    dataIndex: 'businessName',
    key: 'businessName',
    render: (text, record) => (
      <a onClick={() => fetchAndShowBusiness(record.businessId)}>{text}</a>  // Assuming businessId is part of record

       
    ),
    width: 200,
  },
  {
    title: 'Service Name',
    dataIndex: 'serviceName',
    key: 'serviceName',
    render: (text, record) => {
      // console.log('Record Data:', record);  // Log the entire record to see available fields
      return (
        <a onClick={() => viewService(record.serviceId)}>{text}</a>
      );
    },
    width: 200,
  },
  {
    title: 'Claimed At',
    dataIndex: 'claimDate',
    key: 'claimDate',
    sorter: (a, b) => new Date(a.claimDate) - new Date(b.claimDate),
    width: 180,
  },
  {
    title: 'Actions',
    key: 'actions',
    width: 200,
    render: (_, record) => (
      <Space size="middle">
        <Button
          type="primary"
          icon={<CheckOutlined />}
          onClick={() => approveServiceClaimAction(record)}
          size="small"
        >
          Approve
        </Button>
        <Button
          type="danger"
          icon={<CloseOutlined />}
          onClick={() => denyServiceClaimAction(record)}
          size="small"
        >
          Deny
        </Button>
      </Space>
    ),
  },
];


 // **Approve Service Claim Action Handler**
 const approveServiceClaimAction = async (claim) => {
  Modal.confirm({
    title: 'Are you sure?',
    content: `Do you want to approve the service claim "${claim.serviceName}" for "${claim.businessName}"?`,
    okText: 'Approve',
    okType: 'primary',
    cancelText: 'Cancel',
    onOk: async () => {
      setLoadingAction(true);
      try {
        await approveServiceClaim(claim.serviceId, claim.businessId);
        // Remove the approved claim from the list
        setServiceClaims(prev => prev.filter(sc => sc.key !== claim.key));
        setFilteredServiceClaims(prev => prev.filter(sc => sc.key !== claim.key));
        message.success('Service claim approved successfully.');
      } catch (error) {
        message.error(`Failed to approve service claim: ${error.message}`);
      } finally {
        setLoadingAction(false);
      }
    },
  });
};

// **Deny Service Claim Action Handler**
const denyServiceClaimAction = async (claim) => {
  Modal.confirm({
    title: 'Are you sure?',
    content: `Do you want to deny the service claim "${claim.serviceName}" for "${claim.businessName}"?`,
    okText: 'Deny',
    okType: 'danger',
    cancelText: 'Cancel',
    onOk: async () => {
      setLoadingAction(true);
      try {
        await denyServiceClaim(claim.serviceId, claim.businessId);
        // Remove the denied claim from the list
        setServiceClaims(prev => prev.filter(sc => sc.key !== claim.key));
        setFilteredServiceClaims(prev => prev.filter(sc => sc.key !== claim.key));
        message.success('Service claim denied successfully.');
      } catch (error) {
        message.error(`Failed to deny service claim: ${error.message}`);
      } finally {
        setLoadingAction(false);
      }
    },
  });
};

// **Function to view service details (Modal)**
const [selectedService, setSelectedService] = useState(null);
const [isServiceDetailModalVisible, setIsServiceDetailModalVisible] = useState(false);

const viewService = async (serviceId) => {
  // console.log('Viewing service details for:', serviceId); // Debug
  try {
      const serviceDetails = await fetchServiceById(serviceId);
              // console.log('Service Details:', serviceDetails); // Check what details are being fetched

      setSelectedService(serviceDetails);
      setIsServiceDetailModalVisible(true);
  } catch (error) {
      message.error("Failed to load service details.");
      // console.error("Error fetching service details:", error);
  }
};


const handleServiceDetailCancel = () => {
  setIsServiceDetailModalVisible(false);
  setSelectedService(null);
};

  // Open Business Details Modal
  const openBusinessModalForService = (record) => {
    const business = businesses.find((b) => b.key === record.businessKey);
    // console.log('Opening Business Modal for:', business);
    if (business) {
      setSelectedBusiness(business);
      setIsEditModalVisible(false);
      setIsViewModalVisible(true);
    } else {
      message.error('Business details not found.');
    }
  };

  const openBusinessModal = (record) => {
    setSelectedBusiness(record);
    setIsViewModalVisible(true);
  };

  // Open Service Claim Details Modal
  const openServiceModal = (record) => {
    // console.log('Opening Service Claim Modal for:', record);
    setSelectedServiceClaim(record);
    setIsServiceModalVisible(true);
  };

  // Open Edit Modal
  const openEditModal = (business) => {
    setSelectedBusiness(business);
    setIsViewModalVisible(false);
    setIsEditModalVisible(true);
  };


  // Handle closing the view modal
  const handleViewOk = () => {
    setIsViewModalVisible(false);
  };


  // Handle closing the service modal
  const handleServiceOk = () => {
    setIsServiceModalVisible(false);
  };

  const handleServiceCancel = () => {
    setIsServiceModalVisible(false);
  };


  const generateAllApprovedReports = () => {
    message.info('Generating reports for all approved businesses.');
    // Implement bulk report generation here
  };

  const messageAllApprovedBusinesses = () => {
    message.info('Messaging all approved businesses.');
    // Implement bulk messaging here
  };

    if (loadingBusinesses || loadingServiceClaims ) {

    // Display a loading spinner while the page data is loading
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
                      </div>
    );
  }

  return (
    <div style={{ padding: '24px', maxWidth: '1600px', margin: '0 auto' }}>
      <Title level={3}>Business Management</Title>
      <Tabs defaultActiveKey="1" type="card">
        {/* Business Tab */}
        <TabPane tab="Business" key="1">
          <Space
            style={{
              marginBottom: 16,
              flexWrap: 'wrap',
              alignItems: 'center',
            }}
          >
            <Input
              placeholder="Search businesses"
              onChange={(e) => setSearchValue(e.target.value)}
              style={{ height: '38px', lineHeight: '38px', width: '600px' }} // Adjust input size
              />
            <Button
              icon={<MessageOutlined />}
              onClick={messageAllBusinesses}
            >
              Message All Businesses
            </Button>
          
          </Space>
            <Table
              columns={columns}
              dataSource={filteredBusinesses}
              rowKey="id"
              pagination={{
                position: ['bottomCenter'], // Centers pagination at the bottom
                current: currentPage,
                pageSize: pageSize,
                total: filteredBusinesses.length,
                showSizeChanger: true,
                pageSizeOptions: ['10', '30', '50', '100'],
                onChange: handlePageChange,
              }}
              style={{ cursor: 'default' }}
              scroll={{ x: 'auto' }}
            />
        </TabPane>

       
      </Tabs>

      {/* Business Details Modal */}
      <Modal
  title="Business Details"
  visible={isViewModalVisible}
  onCancel={handleViewCancel}
  footer={[
    <Button key="close" onClick={handleViewCancel}>
      Close
    </Button>,
  ]}
  width={800}
>
  {selectedBusiness && (
    <Descriptions
      bordered
      column={1}
      size="small"
    >
      <Descriptions.Item label="Name">
        {selectedBusiness.name}
      </Descriptions.Item>
      <Descriptions.Item label="Email">
        {selectedBusiness.email}
      </Descriptions.Item>
      <Descriptions.Item label="Location">
        {selectedBusiness.location}
      </Descriptions.Item>
      <Descriptions.Item label="Type of Entity">
        {selectedBusiness.typeOfEntity}
      </Descriptions.Item>
      <Descriptions.Item label="Role">
        {selectedBusiness.businessRole}
      </Descriptions.Item>
      <Descriptions.Item label="Bank Account Number">
        {selectedBusiness.bankAccountNumber}
      </Descriptions.Item>
      <Descriptions.Item label="Routing Number">
        {selectedBusiness.routingNumber}
      </Descriptions.Item>
      <Descriptions.Item label="Documents">
        {selectedBusiness.documents && selectedBusiness.documents.map((doc, index) => (
          <div key={index}>
            <a href={doc} style={{ color: '#1890ff', fontWeight: 'bold' }} target="_blank" rel="noopener noreferrer">
              Document {index + 1}
            </a>
          </div>
        ))}
      </Descriptions.Item>
      <Descriptions.Item label="Status">
        {selectedBusiness.active ? 'Active' : 'Inactive'}
      </Descriptions.Item>
    </Descriptions>
  )}
</Modal>


      {/* Edit Business Modal */}
      <Modal
        title="Edit Business Details"
        visible={isEditModalVisible}
        onOk={handleEditOk}
        onCancel={handleEditCancel}
        okText="Save"
        confirmLoading={loadingAction}
        width={800}
      >
        {editingBusiness && (
          <Form layout="vertical" form={form} initialValues={editingBusiness}>
            <Form.Item label="Name" name="name">
              <Input />
            </Form.Item>
            {/* <Form.Item label="Email" name="email">
              <Input />
            </Form.Item> */}
            <Form.Item label="Location" name="location">
              <Input />
            </Form.Item>
            <Form.Item label="Type of Entity" name="typeOfEntity">
              <Input />
            </Form.Item>
            <Form.Item label="Role" name="businessRole">
              <Select>
                <Option value="owner">Owner</Option>
                <Option value="manager">Manager</Option>
                <Option value="staff">Staff</Option>
              </Select>
            </Form.Item>
            <Form.Item label="Bank Account Number" name="bankAccountNumber">
              <Input />
            </Form.Item>
            <Form.Item label="Routing Number" name="routingNumber">
              <Input />
            </Form.Item>
            {/* Additional fields can be added here */}
          </Form>
        )}
      </Modal>

      {/* Message Modal */}
      <Modal
        title={recipient ? `Send Message to ${recipient.name}` : 'Send Message to All Businesses'}
        visible={isMessageModalVisible}
        onOk={handleSendMessage}
        onCancel={() => setIsMessageModalVisible(false)}
        okText="Send"
        confirmLoading={loadingAction}
      >
        <Form layout="vertical">
          <Form.Item label="Message">
            <Input.TextArea
              rows={4}
              value={messageContent}
              onChange={(e) => setMessageContent(e.target.value)}
            />
          </Form.Item>
        </Form>
      </Modal>
      {/* Business Details Modal */}
      <Modal
        title="Business Details"
        visible={isViewModalVisible}
        onOk={handleViewOk}
        onCancel={handleViewCancel}
        footer={[
          <Button key="close" onClick={handleViewCancel}>
            Close
          </Button>,
        ]}
        width={800}
      >
        {selectedBusiness && (
          <Descriptions
            bordered
            column={1}
            size="small"
          >
            <Descriptions.Item label="Name">
              {selectedBusiness.name}
            </Descriptions.Item>
            <Descriptions.Item label="Email">
              {selectedBusiness.email}
            </Descriptions.Item>
            <Descriptions.Item label="Location">
              {selectedBusiness.location}
            </Descriptions.Item>
            <Descriptions.Item label="Type of Entity">
              {selectedBusiness.typeOfEntity}
            </Descriptions.Item>
            <Descriptions.Item label="Role">
              {selectedBusiness.businessRole}
            </Descriptions.Item>
            <Descriptions.Item label="Bank Account Number">
              {selectedBusiness.bankAccountNumber}
            </Descriptions.Item>
            <Descriptions.Item label="Routing Number">
              {selectedBusiness.routingNumber}
            </Descriptions.Item>
            <Descriptions.Item label="Documents">
              {selectedBusiness.documents.map((doc, index) => (
                <div key={index}>
                  <a href={doc} style={{ color: '#1890ff', fontWeight: 'bold' }} target="_blank" rel="noopener noreferrer">
                    Document {index + 1}
                  </a>
                </div>
              ))}
            </Descriptions.Item>
            <Descriptions.Item label="Created At">
              {selectedBusiness.createdAt}
            </Descriptions.Item>
            {/* Uncomment if 'onBehalf' is a valid field */}
            {/* <Descriptions.Item label="On Behalf">
              {selectedBusiness.onBehalf ? 'Yes' : 'No'}
            </Descriptions.Item> */}
            <Descriptions.Item label="Status">
              {selectedBusiness.active ? 'Active' : 'Inactive'}
            </Descriptions.Item>
          </Descriptions>
        )}
      </Modal>

    

    {/* Service Claim Details Modal */}

    <Modal
    title="Service Details"
    visible={isServiceDetailModalVisible}
    onCancel={() => setIsServiceDetailModalVisible(false)}
    footer={[
        <Button key="back" onClick={() => setIsServiceDetailModalVisible(false)}>
            Close
        </Button>
    ]}
    width={800}
>
    {selectedService && (
        <Descriptions bordered column={1} size="small">
            <Descriptions.Item label="Name">{selectedService.name}</Descriptions.Item>
            <Descriptions.Item label="Address">{selectedService.address}</Descriptions.Item>
            <Descriptions.Item label="Description">{selectedService.description}</Descriptions.Item>
            <Descriptions.Item label="Email">{selectedService.email}</Descriptions.Item>
            <Descriptions.Item label="Phone Number">{selectedService.phone_number}</Descriptions.Item>
            <Descriptions.Item label="Website">
                <a href={selectedService.website} style={{ color: '#1890ff', fontWeight: 'bold' }} target="_blank" rel="noopener noreferrer">
                {selectedService.website}
                </a>
            </Descriptions.Item>
        </Descriptions>
    )}
</Modal>

    </div>
  );
};

export default AdminBusinessManagement;
